<div class="cardsContainer">
    <div class="cardsColumn">
        <lib-generic-card
            [title]="'Main Info'"
            [highlight]="true"
            [factory]="factory"
            [configItems]="cardsConfig[entityCardSection.CompanyMainInfo]"
            [hasArchivedItems]="usersHasArchived"
            #mainInfoCard
        >
        </lib-generic-card>

        <lib-generic-card
            [title]="'Main Contact'"
            [factory]="factory"
            [configItems]="cardsConfig[entityCardSection.CompanyMainContact]"
            [hasArchivedItems]="contactHasArchived"
        >
        </lib-generic-card>

        <lib-generic-card
            [title]="'Account Info'"
            [factory]="factory"
            [configItems]="cardsConfig[entityCardSection.CompanyAccountInfo]"
            [hasArchivedItems]="accountHasArchived"
        >
        </lib-generic-card>
    </div>

    <div class="cardsColumn">
        <lib-generic-card
            [title]="'Main Office'"
            [factory]="factory"
            [configItems]="cardsConfig[entityCardSection.CompanyMainOffice]"
            [hasArchivedItems]="buildingHasArchived"
        >
        </lib-generic-card>

        @if (
            cardsConfig[entityCardSection.CompanyCustomInfo] && cardsConfig[entityCardSection.CompanyCustomInfo].length
        ) {
            <lib-generic-card
                [title]="'Custom Info'"
                [factory]="factory"
                [configItems]="cardsConfig[entityCardSection.CompanyCustomInfo]"
                #customInfoCard
            >
            </lib-generic-card>
        }
    </div>
</div>
